<template>
  <Modal :open="isOpen" @close="closeSellerUpdateModal">
    <VeeForm v-slot="{ handleSubmit }" :validation-schema="schema" as="div">
      <form class="space-y-4" @submit="handleSubmit($event, updateSeller)" ref="saleCreationForm">
        <div class="grid grid-cols-2 gap-x-4 gap-y-3">
          <div class="flex-1">
            <label for="firstName" class="block text-sm text-gray-700">
              Prénom
              <span class="ml-1 text-red-600">*</span>
            </label>
            <Field
              type="text"
              name="localSeller.firstName"
              id="firstName"
              autocomplete="given-name"
              class="shadow-xs focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md"
              placeholder="John"
              v-model="localSeller.firstName"
            />
            <ErrorMessage name="localSeller.firstName" class="mt-2 text-sm text-red-600" />
          </div>
          <div class="flex-1">
            <label for="lastName" class="block text-sm text-gray-700">
              Nom
              <span class="ml-1 text-red-600">*</span>
            </label>
            <Field
              type="text"
              name="localSeller.lastName"
              id="lastName"
              autocomplete="family-name"
              class="shadow-xs focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md"
              placeholder="Doe"
              v-model="localSeller.lastName"
            />
            <ErrorMessage name="localSeller.lastName" class="mt-2 text-sm text-red-600" />
          </div>
        </div>
        <div class="flex justify-center">
          <div>
            <button
              class="border border-transparent text-button-font-primary bg-primary px-4 py-2 text-sm font-medium uppercase transition duration-300 transform hover:scale-105 rounded-lg focus:outline-hidden"
              type="submit"
            >
              {{ $t("Complete") }}
            </button>
          </div>
        </div>
      </form>
    </VeeForm>
  </Modal>
</template>

<script>
import { Form as VeeForm, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import { mapActions } from "vuex";
import { Modal, isPresent } from "@estaly/ui";

export default {
  components: {
    VeeForm,
    Field,
    ErrorMessage,
    Modal,
  },

  props: {
    isOpen: Boolean,
    selectedSeller: Object,
  },

  emits: ["getSellers", "closeSellerUpdate"],

  data: () => {
    const schema = yup.object({
      localSeller: yup.object({
        firstName: yup.string().required("Le prénom du vendeur est requis.").nullable(),
        lastName: yup.string().required("Le nom du vendeur est requis.").nullable(),
      }),
    });

    return {
      schema,
      localSeller: {
        firstName: "",
        lastName: "",
      },
    };
  },

  watch: {
    selectedSeller: {
      handler(newValue) {
        if (newValue) this.localSeller = { ...newValue };
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("sellers", ["update"]),

    isPresent,

    closeSellerUpdateModal() {
      this.$emit("closeSellerUpdate");
    },

    async updateSeller() {
      const response = await this.update({
        id: this.selectedSeller.id,
        data: {
          first_name: this.localSeller.firstName,
          last_name: this.localSeller.lastName,
        },
      });
      if (!response?.success) return;

      this.$emit("getSellers");
      this.closeSellerUpdateModal();
    },
  },
};
</script>
